<template>
    <div class="current-content">
        <v-layout row wrap justify-center>
            <v-flex xs12 sm12 md4>
                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Germplasm Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Species</td>
                                <td>{{ (DetailInfo.species||{}).name || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Ecology</td>
                                <td>{{ DetailInfo.ecology || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Population Size</td>
                                <td>{{ DetailInfo.populationSize || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Sample Number</td>
                                <td>{{ DetailInfo.sampleNumber || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Sample Character</td>
                                <td>{{ DetailInfo.sampleCharacter || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Count Number</td>
                                <td>{{ DetailInfo.countNumber || '-' }}</td>
                            </tr>

                            <tr>
                                <td>Height</td>
                                <td>{{ DetailInfo.height || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Created At</td>
                                <td>{{ formatCreationTime(DetailInfo.creationTime) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Collection Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Accession Date</td>
                                <td>{{ formatDate(DetailInfo.accessionDate) }}</td>
                            </tr>
                            <tr>
                                <td>Accession Number</td>
                                <td>{{ DetailInfo.accessionNumber ||'-' }}</td>
                            </tr>
                            <tr>
                                <td>Collector</td>
                                <td>{{ DetailInfo.collector ||'-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Bunch Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Bunch Breath</td>
                                <td>{{ DetailInfo.bunchBreath || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Bunch Depth</td>
                                <td>{{ DetailInfo.bunchDepth || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Bunch Length</td>
                                <td>{{ DetailInfo.bunchLength || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Bunch Remarks</td>
                                <td>{{ DetailInfo.bunchRemarks || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Bunch Spine Characteristic</td>
                                <td>{{ DetailInfo.bunchSpineCharacteristic || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Bunch Weight</td>
                                <td>{{ DetailInfo.bunchWeight || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Leaflet Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Leaflet Count</td>
                                <td>{{ DetailInfo.leafletCount || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Leaflet Length</td>
                                <td>{{ DetailInfo.leafletLength || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Leaflet Width</td>
                                <td>{{ DetailInfo.leafletWidth || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Rachis Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Stem</td>
                                <td>{{ DetailInfo.stem || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Rachis Depth</td>
                                <td>{{ DetailInfo.rachisDepth || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Rachis Length</td>
                                <td>{{ DetailInfo.rachisLength || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Rachis Width</td>
                                <td>{{ DetailInfo.rachisWidth || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

		  	
                <br>
            </v-flex>

            <v-flex xs12 sm12 md4>
                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Fruit Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Fruit Colour</td>
                                <td>{{ (DetailInfo.fruitColour||{}).name || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Fruit Type</td>
                                <td>{{ (DetailInfo.fruitType||{}).name || '-' }}</td>
                            </tr>

                            <tr>
                                <td>Economic Use</td>
                                <td>{{ DetailInfo.economicUse || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Location Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Altitude</td>
                                <td>{{ DetailInfo.altitude || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Latitude</td>
                                <td>{{ DetailInfo.latitude || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Longitude</td>
                                <td>{{ DetailInfo.longitude || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Location</td>
                                <td>{{ (DetailInfo.location||{}).name || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Village</td>
                                <td>{{ DetailInfo.village || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Province</td>
                                <td>{{ DetailInfo.province || '-' }}</td>
                            </tr>
                            <tr>
                                <td>Country</td>
                                <td>{{ (DetailInfo.country||{}).name || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <br>

                <div class="card layoutSpace">
                    <table v-if="isGermplasmInfo" class="table">
                        <thead>
                            <tr>
                                <th colspan="2">Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ DetailInfo.remarks || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
	  	  	
                <!-- 
		  	<div class="card layoutSpace">
		  		<span style="padding: 0.75rem; font-weight: bold">Pictures</span>
		  		<v-carousel>
		  		  <v-carousel-item
		  		    v-for="(picture,i) in pictures"
		  		    :key="i"
		  		    :src="picture.src"
		  		  ></v-carousel-item>
		  		</v-carousel>
		  	</div> -->
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

export default {
    props: ["GermplasmInfo"],
    data () {
        return {
            msg: "Germplasm Detail",
            isGermplasmInfo: false,
            pictures: [
				        {
				          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
				        },
				        {
				          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
				        },
				        {
				          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
				        },
				        {
				          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
				        }
				      ], 
            DetailInfo: {},
        };
    },
    watch: {
        GermplasmInfo() {
            var self = this;
            this.$nextTick(function() {
                self.isGermplasmInfo = true;
                if (self.GermplasmInfo) {
                    self.DetailInfo = self.GermplasmInfo;
                }
                else {
                    self.DetailInfo = {};
                }
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Germplasm/GermplasmDetail.vue